import { REQUIREMENT_RESOURCE } from "@src/appV2/Requirement/constants";
import { requirementSchema } from "@src/appV2/Requirement/types";
import { z } from "zod";

import { Resources } from "./resources";

// eslint-disable-next-line no-restricted-syntax
export enum WorkerDocumentStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

// eslint-disable-next-line no-restricted-syntax
export enum WorkerRequirementDomain {
  FLEX = "FLEX",
  HIRING = "HIRING",
}

const getDocumentsRequestFilterSchema = z.object({
  hcpId: z.string(),
  hcfId: z.string().optional(),
  status: z.nativeEnum(WorkerDocumentStatus).optional(),
  domains: z.array(z.nativeEnum(WorkerRequirementDomain)).optional(),
  archived: z.boolean().optional(),
  fetchLatest: z.boolean(),
});
export type GetDocumentsRequestFilterDto = z.infer<typeof getDocumentsRequestFilterSchema>;

export const getDocumentsRequestSchema = z.object({
  filter: getDocumentsRequestFilterSchema,
  include: z.array(z.literal(Resources.REQUIREMENTS)).optional(),
});
export type GetDocumentsRequestDto = z.infer<typeof getDocumentsRequestSchema>;

const apiResponseWorkerDocumentSchema = z.object({
  attributes: z.object({
    hcpId: z.string(),
    requirementId: z.string(),
    uploadedForRequirementId: z.string().optional(),
    status: z.string(),
    expiry: z.string().optional(),
    issueDate: z.string().optional(),
    archived: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    fileStorageRootFolder: z.string().optional(),
    fileStorageFileKey: z.string().optional(),
    subType: z.string().optional(),
  }),
  id: z.string(),
  type: z.literal(Resources.WORKER_DOCUMENTS),
  relationships: z
    .object({
      requirement: z.object({
        data: z.object({
          id: z.string(),
          type: z.literal(REQUIREMENT_RESOURCE),
        }),
      }),
    })
    .optional(),
});
export type ApiResponseWorkerDocument = z.infer<typeof apiResponseWorkerDocumentSchema>;

// FIXME: Automatically disabled during ESLint config update
const transformedWorkerDocumentSchema = apiResponseWorkerDocumentSchema.extend({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attributes: apiResponseWorkerDocumentSchema.shape.attributes.extend({
    requirement: requirementSchema.nullish(),
  }),
});

export type WorkerDocument = z.infer<typeof transformedWorkerDocumentSchema>;

export const getDocumentsResponseSchema = z.object({
  data: z.array(apiResponseWorkerDocumentSchema),
  included: z.array(requirementSchema).optional(),
});
export type GetDocumentsResponse = z.infer<typeof getDocumentsResponseSchema>;

export const distributionUrlResponseSchema = z.object({
  attributes: z.object({
    distributionUrl: z.string(),
  }),
  id: z.string(),
  type: z.literal(Resources.DISTRIBUTION_URL),
});

export type DistributionUrlResponse = z.infer<typeof distributionUrlResponseSchema>;

export const distributionUrlApiResponseSchema = z.object({
  data: distributionUrlResponseSchema,
});

export type DistributionUrlApiResponse = z.infer<typeof distributionUrlApiResponseSchema>;

export const documentZendeskTicketSchema = z.object({
  id: z.string(),
  type: z.literal(Resources.HCP_DOCUMENT_ZENDESK_TICKET),
  attributes: z.object({
    url: z.string(),
    subject: z.string().optional(),
    description: z.string().optional(),
  }),
});
export type DocumentZendeskTicket = z.infer<typeof documentZendeskTicketSchema>;

export const getDocumentZendeskTicketsResponseSchema = z.object({
  data: z.array(documentZendeskTicketSchema),
});
export type GetDocumentZendeskTicketsResponse = z.infer<
  typeof getDocumentZendeskTicketsResponseSchema
>;
